var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"imageSlider",class:['image-slider', _vm.theme ? ("image-slider--" + _vm.theme) : null]},_vm._l((_vm.data.images),function(image,index){return _c('div',{key:index,staticClass:"image-slider__image",attrs:{"data-item-id":image.id}},[_c('Figure',{ref:index,refInFor:true,attrs:{"data":{
        default: image,
        ratio: _vm.theme === 'image-bank' ? false : true,
        object_fit: 'contain',
      }}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }